import {
  SET_TOTAL_ORDER_RECORDS,
  LOAD_ORDERS_LIST,
  LOAD_ORDER_DETAIL,
  SET_ORDERS_LIST,
  SET_ORDER_DETAIL,
  SET_SELECTED_RECIPIENT,
  ADD_PRODUCT_TO_SHOPPING_BAG,
  REMOVE_PRODUCT_FROM_SHOPPING_BAG,
  INCREASE_ITEM_SHOPPING_BAG,
  DECREASE_ITEM_SHOPPING_BAG,
  SET_CARD_MESSAGE,
  SET_ORDER_ID,
  SET_CONFIRMED_ORDER_RECIPIENT,
  CLEAR_ORDER,
  RESET_ORDER_STATE,
  DISABLE_PAY_BUTTON,
  SET_SELECTED_TEMPLATE,
  SET_SALESFORCE_RESOURCE_TYPE,
  SET_SALESFORCE_RECORD_UID,
  IS_CREATING_ORDER,
  SET_ALL_TEAM_ORDERS,
  SET_CHECK_INVENTORY_RESPONSE, UPDATE_ITEM_QTY_SHOPPING_BAG
} from '@/state/mutationTypes';
import getOrderStoreDefaultState from '@/state/orderStore/orderStoreDefaultState'

export default {
  [SET_CHECK_INVENTORY_RESPONSE](state, payload) {
    state.checkInventoryResponse = payload
  },
  [SET_ALL_TEAM_ORDERS](state, payload) {
    state.allTeamOrders = payload
  },
  [LOAD_ORDERS_LIST](state, payload) {
    state.ordersListLoading = payload
  },
  [LOAD_ORDER_DETAIL](state, payload) {
    state.orderDetailLoading = payload
  },
  [SET_ORDERS_LIST](state, resultingOrders) {
    state.currentOrdersList = [...resultingOrders]
  },
  [SET_TOTAL_ORDER_RECORDS](state, payload) {
    state.totalRecords = payload
  },
  [SET_ORDER_DETAIL](state, orderObject) {
    state.individualOrder = orderObject
  },
  [ADD_PRODUCT_TO_SHOPPING_BAG](state, payload) {
    state.shoppingBagProducts = payload
  },
  [REMOVE_PRODUCT_FROM_SHOPPING_BAG](state, product) {
    const productIndex = state.shoppingBagProducts.indexOf(product)

    if (productIndex > -1) {
      state.shoppingBagProducts.splice(productIndex, 1)
    }
  },
  [INCREASE_ITEM_SHOPPING_BAG](state, productIndex) {
    state.shoppingBagProducts[productIndex].quantity += 1
  },
  [DECREASE_ITEM_SHOPPING_BAG](state, productIndex) {
    state.shoppingBagProducts[productIndex].quantity -= 1
  },
  [UPDATE_ITEM_QTY_SHOPPING_BAG](state, { productIndex, quantity }) {
    state.shoppingBagProducts[productIndex].quantity = quantity
  },
  [SET_SELECTED_RECIPIENT](
    state,
    { recipientId, recipientResourceType, salesForceRecipient }
  ) {
    state.selectedRecipientId = recipientId
    state.recipientResourceType = recipientResourceType
    state.salesForceRecipient = salesForceRecipient
  },
  [SET_CARD_MESSAGE](state, cardMessage) {
    state.cardMessage = cardMessage
  },
  [SET_SELECTED_TEMPLATE](state, payload) {
    state.selectedTemplateId = payload
  },
  [SET_ORDER_ID](state, payload) {
    state.currentOrderId = payload
  },
  [SET_CONFIRMED_ORDER_RECIPIENT](state, payload) {
    state.confirmedOrderForRecipient = payload
  },
  [CLEAR_ORDER](state) {
    state.individualOrder = {}
    state.shoppingBagProducts = []
    state.selectedRecipientId = null
    state.cardMessage = ''
    state.selectedShippingOptionId = null
    state.currentOrderId = null
    state.salesForceRecipient = {}
    state.recipientResourceType = null
    state.selectedTemplateId = 0
    state.salesforceResourceType = ''
    state.salesforceResourceUID = null
  },
  [DISABLE_PAY_BUTTON](state, payload) {
    state.disabledPayButton = payload
  },
  [SET_SALESFORCE_RESOURCE_TYPE](state, payload) {
    state.salesforceResourceType = payload
  },
  [SET_SALESFORCE_RECORD_UID](state, payload) {
    state.salesforceResourceUID = payload
  },
  [IS_CREATING_ORDER](state, payload) {
    state.isCreatingOrder = payload
  },
  [RESET_ORDER_STATE](state) {
    Object.assign(state, getOrderStoreDefaultState())
  }
}
